export default __webpack_public_path__ + "static/media/how-it-works-2.d550ee21.png";